export default "<p class=\"text\">\n  {{text}}\n</p>\n";